module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/07_Acknowledge"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_Part1"
    }
  }, [_vm._v("PART I. HISTORY AND THEORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_chapter1"
    }
  }, [_vm._v("1. The Art Film")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Economic Links")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Euro-American Art Film: Definition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Euro-American Art Film: History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Cultural Dominance or Cultural Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II. CASE STUDIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Part2#intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Art and Commerce in "), _c('i', [_vm._v("Contempt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Blow-Up")]), _vm._v(", Swinging London, and the Film Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Pasolini’s "), _c('i', [_vm._v("The Canterbury Tales")]), _vm._v(": The Estrangement of an English Classic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('i', [_vm._v("Paris, Texas")]), _vm._v(", an American Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('i', [_vm._v("The Last Emperor:")]), _vm._v(" Pleasures and Dangers of the Exotic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Final Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_Film",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filmography: Euro-American Art Films")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_Biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bac375f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_content.vue
// module id = 72
// module chunks = 0